import styled from 'styled-components';

/* eslint-disable import/prefer-default-export */
export const AppContainer = styled.div`
  height: 100dvh;
  margin: 0px;
`;
